<iframe
  [height]="styles?.height.px"
  [width]="styles?.width.px"
  [src]="safeUrl"
  title="YouTube video player"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowfullscreen
  style="border: 0"
></iframe>
